import { render } from "./ScrollToTopComponnet.vue?vue&type=template&id=32daddeb"
import script from "./ScrollToTopComponnet.vue?vue&type=script&lang=js"
export * from "./ScrollToTopComponnet.vue?vue&type=script&lang=js"

import "./ScrollToTopComponnet.vue?vue&type=style&index=0&id=32daddeb&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__